import { Directive } from '@angular/core';
import { DomController, IonContent } from '@ionic/angular';
import { WindowRef } from '../../../window-ref.service';

@Directive({
  selector: '[appTouchScrollFix]'
})
export class TouchScrollFixDirective {

  private _content: IonContent;
  private _scrollElement: HTMLElement;
  private _scrolling: boolean;
  private _scrollData: { x: number, y: number } = { x: undefined, y: undefined };
  private _lastScrollData: { x: number, y: number } = { x: undefined, y: undefined };

  private _onMouseDown: (event: MouseEvent) => void = undefined;
  private _onMouseMove: (event: MouseEvent) => void = undefined;
  private _onMouseUp: (event: MouseEvent) => void = undefined;
  private _onMouseClick: (event: MouseEvent) => void = undefined;

  constructor(
    content: IonContent,
    private domCtrl: DomController,
    private winRef: WindowRef
  ) {
    this._content = content;
    this.initialize();
  }


  // private

  private async initialize(): Promise<void> {
    this._scrollElement = await this._content.getScrollElement();
    const _window = this.winRef.nativeWindow as Window;
    const _document = this.winRef.nativeWindow.document as Document;

    this.domCtrl.write(() => {
      this._scrollElement.removeEventListener('mousedown', this._onMouseDown);
      this._scrollElement.removeEventListener('click', this._onMouseClick);
      _window.removeEventListener('mouseup', this._onMouseUp);
      _window.removeEventListener('mousemove', this._onMouseMove);

      this._scrollElement.addEventListener('click', this._onMouseClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
      });

      this._scrollElement.addEventListener('mousedown', this._onMouseDown = (e) => {
        const clickedTagName = (e.target as any).tagName;

        if (clickedTagName === "SELECT" || clickedTagName === "INPUT" || clickedTagName === "TEXTAREA" ) {
          return true
        }
  
        if (!this._scrollElement.hasAttribute('nochilddrag') || _document.elementFromPoint( e.pageX, e.pageY ) === this._scrollElement) {
          this._scrolling = true;
          this._lastScrollData.x = e.clientX;
          this._lastScrollData.y = e.clientY;
          e.preventDefault();
        }
      });
  
      _window.addEventListener('mouseup', this._onMouseUp = () => {
        this._scrolling = false;
        this.winRef.scrolling = false;
      });
  
      _window.addEventListener('mousemove', this._onMouseMove = (e) => {
        if (this._scrolling) {
          this.winRef.scrolling = true;
          this._scrollElement.scrollLeft -= this._scrollData.x = (- this._lastScrollData.x + (this._lastScrollData.x = e.clientX));
          this._scrollElement.scrollTop -= this._scrollData.y = (- this._lastScrollData.y + (this._lastScrollData.y = e.clientY));
  
          if (this._scrollElement == _document.body) {
            _document.body.scrollLeft -= this._scrollData.x;
            _document.body.scrollTop -= this._scrollData.y;
          }
        }
      });
    });
  }
}
